import { z } from 'zod';

function parseJsonEnvVar<T>(
  value: string | undefined,
  fallback: T
): string | T {
  if (!value) return fallback;

  try {
    return JSON.parse(value);
  } catch (error) {
    console.warn(`Failed to parse JSON from environment variable:`, value);
    return fallback;
  }
}

export const environmentSchema = z.object({
  apiUrl: z.string().optional(),
  redirectServerApiUrl: z.string().optional(),
  environmentType: z.string().optional(),
  gtmId: z.string().optional(),
  isDevelopment: z.boolean().optional(),
  sentryDsn: z.string().optional(),
  sentryTracesSampleRate: z.number().optional(),
  sentryAllowedUrls: z.array(z.string()).optional(),
  publicUrl: z.string().optional(),
  routerBaseName: z.string().optional(),
  isWebSdk: z.boolean().optional(),
  frontendUrl: z.string().optional(),
  appTenant: z.string().optional(),
  redirectServer: z.boolean().optional(),
});

const apiUrl = process.env.REACT_APP_API_URL;
const redirectServerApiUrl = process.env.REACT_APP_REDIRECT_SERVER_API_URL;
const environmentType = process.env.REACT_APP_ENVIRONMENT;
const gtmId = process.env.REACT_APP_GTM_ID;
const sentryDsn = process.env.REACT_APP_SENTRY_DSN;
const sentryTracesSampleRate = parseJsonEnvVar(
  process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE,
  undefined
);
const sentryAllowedUrls = parseJsonEnvVar(
  process.env.REACT_APP_SENTRY_ALLOWED_URLS,
  undefined
);
const publicUrl = process.env.PUBLIC_URL;
const isWebSdk = parseJsonEnvVar(process.env.REACT_APP_IS_WEB_SDK, false);
const frontendUrl = process.env.REACT_APP_FRONTEND_URL;
const routerBaseName = process.env.REACT_APP_ROUTER_BASENAME;
const appTenant = process.env.REACT_APP_TENANT;
const redirectServer = parseJsonEnvVar(
  process.env.REACT_APP_IS_REDIRECT_SERVER,
  false
);

const env = {
  apiUrl,
  redirectServerApiUrl,
  environmentType,
  gtmId,
  publicUrl,
  isWebSdk,
  frontendUrl,
  routerBaseName,
  appTenant,
  redirectServer,
  isDevelopment: process.env.REACT_APP_ENVIRONMENT === 'development',
  sentryDsn,
  sentryTracesSampleRate,
  sentryAllowedUrls: sentryAllowedUrls
    ? sentryAllowedUrls.split(',').map((url) => url.trim())
    : undefined,
};

export const environment = environmentSchema.parse(env);
